
<div class="d-flex align-items-center" style="height: 100%;">
  <button type="button" class="btn btn-active-light-primary mystack" (click)="openOrder()">
    <i class="fal fa-cart-shopping"></i>
    <div class="stackedtext bg-success" *ngIf="items > 0">{{ items }}</div>
  </button>
</div>